import type { FC, ReactNode } from 'react'
import type { Tone } from '@/types'

import { ArrowDown } from 'lucide-react'
import { Reveal } from '@/components/motion/reveal'
import { ToneSection } from '@/components/generals/tone'

interface ResourceDownloadProps {
    tone?: Tone
    title: string
    description: string
    href: string
}

// A single oversized row that opens the industry's PDF use case.
export const ResourceDownload: FC<ResourceDownloadProps> = ({ tone = 'void', title, description, href }): ReactNode => {
    return (
        <ToneSection tone={tone} id='use-case' className='px-5 py-20 md:px-8 lg:px-12 lg:py-28'>
            <Reveal>
                <a
                    href={href}
                    target='_blank'
                    rel='noopener noreferrer'
                    data-cursor='Open PDF'
                    className='group grid gap-6 border-y border-tone-line py-10 md:grid-cols-12 md:items-center md:py-14'
                >
                    <span className='t-label text-tone-muted md:col-span-2'>
                        Resource · PDF
                    </span>
                    <span className='flex flex-col gap-3 md:col-span-8'>
                        <span className='font-heading text-[clamp(2.25rem,5vw,4.75rem)] font-semibold uppercase leading-[0.9] tracking-[-0.035em] transition-[font-variation-settings] duration-700 ease-out-expo [font-variation-settings:"wdth"_75] group-hover:[font-variation-settings:"wdth"_100]'>
                            {title}
                        </span>
                        <span className='text-tone-muted'>
                            {description}
                        </span>
                    </span>
                    <span className='flex md:col-span-2 md:justify-end'>
                        <span className='flex size-16 items-center justify-center border border-tone-line transition-colors duration-500 group-hover:bg-tone group-hover:text-tone-bg md:size-20'>
                            <ArrowDown className='size-6 transition-transform duration-500 group-hover:translate-y-1' aria-hidden />
                        </span>
                    </span>
                </a>
            </Reveal>
        </ToneSection>
    )
}
